<!-- Barre de progression de navigation globale (chargement d'une page ERP) -->
<div
  class="app-nav-progress"
  [class.app-nav-progress--active]="navLoading$ | async"
  aria-live="polite"
  role="progressbar"
>
  <div class="app-nav-progress__bar" [style.width.%]="navProgress$ | async"></div>
</div>

<!-- Create a template reference to the outlet directive with the template variable assignment #outlet="outlet".
With this reference to the outlet directive, we can get the information of when the router outlet is active to trigger our animations. -->
<div style="background-color: #F7FAFF" [@zoomIn]="zoomIn(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>